import ModalController from "./modal_controller";

export default class extends ModalController {
  static targets = ["modalBox"];

  declare readonly modalBoxTarget: HTMLElement;

  private triggerRect: DOMRect | null = null;

  positionFromEvent(event: Event) {
    const target = event.currentTarget as HTMLElement;
    this.triggerRect = target.getBoundingClientRect();
  }

  open() {
    if (this.triggerRect) {
      this.positionModalBox(this.triggerRect);
    }
    super.open();
  }

  close(event: Event, preventDefault: boolean = true) {
    super.close(event, preventDefault);
    this.triggerRect = null;
    this.modalBoxTarget.addEventListener("transitionend", () => {
      this.modalBoxTarget.style.removeProperty("position");
      this.modalBoxTarget.style.removeProperty("top");
      this.modalBoxTarget.style.removeProperty("left");
    }, { once: true });
  }

  private positionModalBox(rect: DOMRect) {
    const box = this.modalBoxTarget;
    box.style.position = "fixed";

    // Position below the trigger, aligned to its left edge
    let top = rect.bottom + 8;
    let left = rect.left;

    // Measure the box to check for overflow
    const boxWidth = box.offsetWidth || 384;
    const boxHeight = box.offsetHeight || 400;

    // Keep within viewport horizontally
    if (left + boxWidth > window.innerWidth - 16) {
      left = window.innerWidth - boxWidth - 16;
    }
    if (left < 16) left = 16;

    // If no room below, position above the trigger
    if (top + boxHeight > window.innerHeight - 16) {
      top = rect.top - boxHeight - 8;
    }
    if (top < 16) top = 16;

    box.style.top = `${top}px`;
    box.style.left = `${left}px`;
  }
}
